import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import TechImagePanel from '@/components/feature/TechImagePanel';
import Hero from './components/Hero';
import PartyScene from './components/PartyScene';
import RightsSystem from './components/RightsSystem';

export default function Consumption() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="九畴云铺消费体验 | 聚餐场景与权益系统消费引擎"
        description="九畴云铺聚餐场景与权益系统，从新人权益、发起聚餐、到店核销到评价数据回流，演示AI权益餐饮社交消费数据的完整消费引擎。"
        keywords="九畴云铺,聚餐场景,权益系统,消费引擎,数字消费,权益核销"
        path="/jiuchou/consumption"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '九畴云铺消费体验',
          description: '聚餐场景与权益系统消费引擎',
        }}
      />
      <main>
        <Hero />
        <PartyScene />
        <TechImagePanel
          eyebrow="消费引擎"
          title="把 AI、权益、餐饮、社交与数据真正跑起来"
          desc="从新人权益到到店核销、评价与数据回流，九畴云铺的消费引擎让投资人看到一套可真实运转的消费场景。"
          chips={['聚餐场景', '权益系统', '数字消费', '核销']}
          stats={[
            { value: '权益', label: '绑定真实消费' },
            { value: '聚餐', label: '社交场景' },
            { value: '回流', label: '数据闭环' },
          ]}
          imageUrl="https://readdy.ai/api/search-image?query=Abstract%20warm%20dining%20social%20consumption%20scene%2C%20deep%20dark%20ink%20navy%20background%2C%20glowing%20emerald%20and%20gold%20coupon%20and%20red%20packet%20light%20particles%20connecting%20restaurant%20table%20nodes%2C%20digital%20consumption%20engine%2C%20minimal%20geometric%20composition%2C%20cinematic%20lighting%2C%20high%20detail&width=1600&height=900&seq=jiuchou-panel-consume&orientation=landscape"
          imageAlt="九畴云铺 消费引擎"
        />
        <RightsSystem />
      </main>
      <Footer />
    </div>
  );
}